import { render, staticRenderFns } from "./pinghengdan2.vue?vue&type=template&id=36e8d140&scoped=true"
import script from "./pinghengdan2.vue?vue&type=script&lang=js"
export * from "./pinghengdan2.vue?vue&type=script&lang=js"
import style0 from "./pinghengdan2.vue?vue&type=style&index=0&id=36e8d140&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e8d140",
  null
  
)

export default component.exports